module.exports = __webpack_public_path__ + "assets/img/s5-subtitle-1-55a89b13.png";